import { render, staticRenderFns } from "./MyBag.vue?vue&type=template&id=7c082c8a&"
import script from "./MyBag.vue?vue&type=script&lang=js&"
export * from "./MyBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports